import useToast from "@repo/core/components/core/Toast";
import { IModalRefProps } from "@repo/core/components/layout/Modal/types";
import { StoreSelectScaffoldProps } from "@repo/core/components/layout/Scaffolds/StoreSelectScaffold/types";
import { useDimensions } from "@repo/core/hooks/useDimensions";
import { useSelectStore } from "@repo/core/hooks/useSelectStore";
import { useStoresAndShopkeepersStore } from "@repo/core/stores/storesAndShopkeepers";
import { useEffect, useRef } from "react";

export const useStoreSelectScaffoldController = ({
  overrideModalRef,
  showConfirmStoreModal
}: Pick<
  StoreSelectScaffoldProps,
  "overrideModalRef" | "showConfirmStoreModal"
>) => {
  const { isMobile } = useDimensions();
  const { success } = useToast();
  const { modalRef, handleOnSelectStore } = useSelectStore({
    overrideModalRef
  });

  const confirmStoreModalRef = useRef<IModalRefProps>(null);

  const {
    selectedStore,
    selectedShopkeeper,
    hasMoreThanOneShopkeeper,
    hasMoreThanOneStore,
    showCorrectStoreAlert
  } = useStoresAndShopkeepersStore();

  const enableSelectStore = hasMoreThanOneStore || hasMoreThanOneShopkeeper;

  const handleOnSelectCancelConfirmStoreModal = () => {
    confirmStoreModalRef.current?.close();
    handleOnSelectStore();
  };

  const onSelectStoreSuccess = () => {
    success("Loja selecionada com sucesso!");
  };

  useEffect(() => {
    if (showConfirmStoreModal && showCorrectStoreAlert) {
      confirmStoreModalRef.current?.open();
    }
  }, [showConfirmStoreModal, showCorrectStoreAlert]);

  return {
    modalRef,
    confirmStoreModalRef,
    handleOnSelectStore,
    handleOnSelectCancelConfirmStoreModal,
    onSelectStoreSuccess,
    selectedStore,
    selectedShopkeeper,
    enableSelectStore,
    isMobile
  };
};
